var defaultURLParamKeys = {
  q: 'q',
  resultsPerPage: 'show',
  page: 'page',
  sort: 'sort'
};

export { defaultURLParamKeys };
//# sourceMappingURL=config.esm.js.map
